const templates =  {
    "shop.okraina.ru": {
        title: "Покупки в магазинах",
        tags: [

        ]
    },
    "dostavka.okraina.ru": {
        title: "Покупки в магазинах",
        tags: [
        ]
    },
}

export default templates;
